import React from 'react';
import { FIELD_TYPES } from '../../constants';
import { useTranslation } from '../../contexts/translation-context';
import styles from './ecom-header.module.scss';
const EcomHeader = _ref => {
  let {
    id,
    fieldType,
    FieldLayout
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.ecomHeader
  }, fieldType === FIELD_TYPES.ECOM_CONTACT_DETAILS ? t('ecom-header.contact-details') : t('ecom-header.shipping-details')));
};
export default EcomHeader;
//# sourceMappingURL=ecom-header.js.map